module.exports = __webpack_public_path__ + "img/resource-tech-image-55.53564578.jpg";